import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert } from '@mui/material';
import { getRoom, updateRoom } from '../services/api';
import RoomForm from '../components/room/RoomForm';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { useNotification } from '../contexts/NotificationContext';

const EditRoom = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const [room, setRoom] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchRoom = async () => {
            try {
                const data = await getRoom(id);
                if (typeof data.roomDetails === 'string') {
                    data.roomDetails = JSON.parse(data.roomDetails);
                }
                setRoom(data);
            } catch (error) {
                console.error('物件取得エラー:', error);
                setError('物件の取得に失敗しました');
            } finally {
                setIsLoading(false);
            }
        };

        fetchRoom();
    }, [id]);

    const handleSubmit = async (formData) => {
        try {
            await updateRoom(id, formData);
            showNotification('物件を更新しました', 'success');
            navigate('/my-rooms');
        } catch (error) {
            console.error('物件更新エラー:', error);
            showNotification('物件の更新に失敗しました', 'error');
        }
    };

    if (isLoading) return <LoadingSpinner />;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (!room) return <Alert severity="error">物件が見つかりません</Alert>;

    return (
        <Container>
            <RoomForm
                initialValues={room}
                onSubmit={handleSubmit}
                isEdit={true}
            />
        </Container>
    );
};

export default EditRoom; 